module.exports = __webpack_public_path__ + "static/media/9DESA18.2213f4b5.jpg";